import React from 'react';
import PropTypes from 'prop-types';

const PamplingLogo = ({ className }) => (
  <svg
    className={`MuiSvgIcon-root ${className}`}
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M23.5808 2.15209L19.1755 1.104C19.1755 1.104 17.9476 3.26559 15 3.26559C12.0524 3.26559 10.8245 1.104 10.8245 1.104L6.41921 2.15209L0 7.90668L3.20143 12.8635L6.41921 11.3556V28.8962H23.5808V11.3556L26.7986 12.8635L30 7.90668L23.5808 2.15209Z" />
  </svg>
);
PamplingLogo.propTypes = {
  className: PropTypes.string,
};
PamplingLogo.defaultProps = {
  className: '',
};

export default PamplingLogo;
